export default {
    baseStyle: {
        container: {
            width: 'full',
            maxWidth: '420px',
            mx: 'auto'
        },
        search: {
            borderWidth: 1
        }
    }
}
